var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPitch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .pitch-st0{fill:none;stroke:#FFFFFF;stroke-width:19.8692;stroke-linecap:round;stroke-miterlimit:10;}\n    .pitch-st1{fill:none;stroke:#FFFFFF;stroke-width:14.9019;stroke-linecap:round;stroke-miterlimit:10;}\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pitch"
  }, /*#__PURE__*/React.createElement("path", {
    className: "pitch-st0",
    d: "M222.7,147.9V253c0,18.4,14.9,33.3,33.3,33.3h0c18.4,0,33.3-14.9,33.3-33.3V147.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "pitch-st0",
    x1: 256,
    y1: 354.8,
    x2: 256,
    y2: 286.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "pitch-st0",
    cx: 256,
    cy: 354.8,
    r: 9.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "lines"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fullRight",
    className: "pitch-st1",
    d: "M333.7,239.7c5.6,3.2,9.4,9.3,9.4,16.3s-3.8,13.1-9.4,16.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "right",
    className: "pitch-st1",
    d: "M333.7,195.4c28.3,5.7,49.7,30.6,49.7,60.6s-21.4,54.9-49.7,60.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "left",
    className: "pitch-st1",
    d: "M178.3,272.3c-5.6-3.2-9.4-9.3-9.4-16.3s3.8-13.1,9.4-16.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fullLeft",
    className: "pitch-st1",
    d: "M178.3,316.6c-28.3-5.7-49.7-30.6-49.7-60.6s21.4-54.9,49.7-60.6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitch);
export default __webpack_public_path__ + "static/media/pitch.ce1aab2b1aaaaead3a5517b3968c08c0.svg";
export { ForwardRef as ReactComponent };